import { Controller } from "stimulus"
import envatoSso from "../utils/envatoSsoInstance"
import SessionManager from "../utils/session_manager"
import { handleError } from "../utils/errors"
import { isSignedOut } from "../utils/session"

export default class extends Controller {
  initialize() {
    if (isSignedOut() && this.isAutoSignInRequired) this.autoSignIn()
  }

  autoSignIn() {
    envatoSso.configure({ serverHost: this.ssoServerDomain })

    this.sessionManager = new SessionManager({
      envatoSso: envatoSso,
      clientSlug: this.ssoClientKey,
      ui: {
        displayError: this.onError,
        showLoginForm: () => {},
      },
    })

    this.sessionManager.autoSignIn()
  }

  onError = (message, e) => {
    // we don't care to report network timeouts when doing auto sign in
    if (message !== "XMLHttpRequest.ontimeout") handleError(e)
  }

  get isAutoSignInRequired() {
    const urlParams = new URL(document.location.toString()).searchParams
    return urlParams.get("auto_signin") === "true"
  }

  get ssoServerDomain() {
    return document.head.querySelector('meta[name="sso_server_domain"]').content
  }

  get ssoClientKey() {
    return document.head.querySelector('meta[name="sso_client_key"]').content
  }
}
